export class QuestionFormData {
  content: string;
  subject: string;
  permission: boolean;
  attachment: string;
  attachmentName: string;
  destinationGroup: string;

  constructor(content: string, subject: string, permission: boolean, attachmentName: string, attachment: string, destinationGroup: string) {
    this.content = content;
    this.subject = subject;
    this.permission = permission;
    this.attachment = attachment;
    this.attachmentName = attachmentName;
    this.destinationGroup = destinationGroup;
  }
}
